module.exports = "<div ui-view=main></div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/settings/hourCodes/hourCodes.html
// module id = 467
// module chunks = 0